import type { Components } from 'react-markdown';

/**
 * Markdown components for UserInstructions.
 * Headings are downgraded to maintain proper HTML hierarchy since the template name is already h3.
 * All other elements (p, ul, ol, li, code, etc.) are rendered as standard HTML by react-markdown
 * and styled automatically by prose classes in the container.
 */
export const markdownComponents: Components = {
  h1: ({ children }) => <h4>{children}</h4>,
  h2: ({ children }) => <h5>{children}</h5>,
  h3: ({ children }) => <h6>{children}</h6>,
  h4: ({ children }) => <h6>{children}</h6>,
  h5: ({ children }) => <h6>{children}</h6>,
};
